import UserContextInfo from "./userContextInfo";
import { shouldAttachUserAccessToken } from "./authToken";

export default function AuthHeader(clientAuth) {
  let user = null;
  try {
    const raw = localStorage.getItem('AccountInfo');
    user = raw ? JSON.parse(raw) : null;
  } catch (err) {
    user = null;
  }

  const normalizeId = (value) => {
    if (!value) return '';
    if (typeof value === 'string' && value.startsWith('No ')) return '';
    return value;
  };

  const userToken = user && typeof user.accesstoken === "string" ? user.accesstoken : "";
  if (shouldAttachUserAccessToken(userToken)) {
    let userAuth = 'Bearer ' + userToken;
    let companyAuth = normalizeId(UserContextInfo.activeCompanyId());
    let platformAuth = normalizeId(UserContextInfo.activePlatformId());
    return {
      'Client-Authorization': clientAuth || '',
      'Authorization': userAuth,
      'Company-Id': companyAuth,
      'K8-Id': platformAuth
    };
  } else return {
    'Client-Authorization': clientAuth || '',
    'Authorization': '',
    'Company-Id': '',
    'K8-Id': ''
  };
}
